import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { getCurrentBoost } from '../subscription.service';
import { subscriptionsKeys } from '../subscriptions.keys';
const FIVE_MINUTES = 5 * 60 * 1000;
export const useGetCurrentBoost = (options) => {
    const subdomain = getSubdomain();
    return useQuery({
        queryKey: subscriptionsKeys.currentBoost(subdomain),
        queryFn: () => getCurrentBoost(subdomain),
        staleTime: FIVE_MINUTES,
        gcTime: FIVE_MINUTES,
        ...(options ?? {}),
    });
};
